/**
 * This route is dynamically added to the app if this section is
 * enabled inside the config for the tenant being built.
 */
// @ngInject
function states($stateProvider, nsUtilProvider) {
  $stateProvider
    .state('manage', {
      parent: 'root',
      redirectTo: '.account',
      url: '/manage',
      templateUrl: 'apps/manage-gpr/templates/acp-manage-gpr.ng.html',
      data: {
        permissions: {
          except: 'hub_user',
          redirectTo: {
            hub_user: 'profile-hub'
          }
        }
      },
      resolve: {
        pageTitle: /* @ngInject */ function(module, $injector) {
          return $injector.invoke(
            nsUtilProvider.getPageTitle('apps/manage-gpr')
          );
        },
        module: /* @ngInject */ function($ocLazyLoad) {
          return import(/* webpackChunkName: "acp.section.manage-gpr" */ 'apps/manage-gpr').then(
            $ocLazyLoad.loadModule
          );
        }
      }
    })
    .state('manage.account', {
      url: '/profile',
      template: '<ui-view />'
    })
    .state('manage.contacts', {
      url: '/contacts',
      template: '<ui-view />',
      data: {
        permissions: {
          only: 'send_money_eligible',
          redirectTo: {
            send_money_eligible: 'dashboard'
          }
        }
      }
    })
    .state('manage.notification-preferences', {
      url: '/notification-preferences',
      template: '<ui-view />'
    });
}

export default states;
